import L from 'leaflet'
import moment from 'moment'

const lo_regions = require('./shape/shape-lo.json')
const hi_regions = require('./shape/shape-hi-3.json')
const shape_6r = require('./shape/shape_6r.json')
const zk = require('./shape/zk04602025_f.json')
const oktmo2name = require('./oktmo.json')
import { code2region } from './reg_map_2_oktmo'

const obj2regions = (obj) => Object.entries(obj).map(([k, v]) => v).reduce((a, e) => {return [...a, ...e]}, [])
const width = (zoom) => Math.min(2, 2 ** (zoom - 2))
const firstRegion = (regions) => Number(regions.split(',')[0])
const reg_centers = require('./reg_centers.json')
const region_keys = Object.keys(lo_regions)
const markerTopTooltipOffset = L.point(0, -6)
const markerBottomTooltipOffset = L.point(0, 12)
const priority_colors = {
	'Особо важно': 'red',
	'Важно': 'orange',
	'Внимание': 'yellow',
	'Информация': 'green',
}
const industry_icon = {
	'Электроэнергетика': 'electric',
	'Теплоэнергетика': 'heat',
	'Газовая промышленность': 'gas',
	'Нефтяная промышленность': 'oil',
	'Угольная промышленность': 'coal',
}
const obj_types = [
  { tableName: "power_station", id: 1, objectType: "Электростанции" },
  { tableName: "electrical_substation", id: 2, objectType: "Электрические подстанции" },
  { tableName: "electrical_line", id: 3, objectType: "Электрические линии" },
  { tableName: "pipeline", id: 4, objectType: "Трубопроводы" },
  { tableName: "storage", id: 5, objectType: "Хранилища" },
  { tableName: "processing_plant", id: 6, objectType: "Перерабатывающие заводы" },
  { tableName: "pumping_station", id: 7, objectType: "Перекачивающие станции" },
  { tableName: "field", id: 8, objectType: "Месторождения" },
  { tableName: "gas_distribution_station", id: 9, objectType: "Газораспределительные станции" },
  { tableName: "terminal", id: 10, objectType: "Терминалы" },
  { tableName: "coal_mine", id: 11, objectType: "Шахты и разрезы" },
  { tableName: "coal_fabric", id: 12, objectType: "Обогатительные фабрики" },
  { tableName: "boiler_room", id: 13, objectType: "Котельные" },
]
const objDBTable = (id) => obj_types.find(e => e.id === id)?.tableName

const existed = (data, arr) => data.find(d => d.ids.some(e => arr.some(el => el === e)))
const datetime = (m) => m.format('DD-MM-YYYY HH:mm') // &nbsp;
const date = (m) => m.format('DD-MM-YYYY') // &nbsp;
const daystime = (minutes) => {
	if (minutes > 10) minutes = 10 * Math.round(minutes / 10)
	if (minutes > 110) minutes = 60 * Math.round(minutes / 60)
	const days = Math.floor( minutes / 60 / 24 )
	return days > 5 ? (days + ' д.') 
		: days > 0 ? days + ' д. ' + moment.utc(minutes * 60 * 1000).format('H ч.')
		: minutes > 119 ? moment.utc(minutes * 60 * 1000).format('H ч.')
		: minutes > 59 ? moment.utc(minutes * 60 * 1000).format('H ч. mm м.')
		: moment.utc(minutes * 60 * 1000).format('m мин.')
}
const midDuration = (data, field) => {
	const arr = data.filter(d => d[field])
	const vol = arr.reduce((a, d) => a + d[field]/arr.length, 0)
	return vol === 0 ? null : vol
}
const fixHtml = (html) => html
	.replaceAll(/<font[^>]*>/g, '')
	.replaceAll(/<\/font[^>]*>/g, '')
	.replaceAll(/<p[^>]*>/g, '<p>')
	.replaceAll(/[\n\r]/g, '')
	.replaceAll(/<a name="_GoBack"><\/a>\s?/g, '')
	.replaceAll(/<br\/?>\s*/g, '<br/>')

const hasValue = (val) => (val !== null) && (val !== undefined)
const isEmpty = (val) => (val === null) || (val === undefined)

export {
	lo_regions,
	hi_regions,
	shape_6r,
	zk,
	oktmo2name,
	code2region,
	obj2regions,
	width,
	region_keys,
	firstRegion,
	reg_centers,
	markerTopTooltipOffset,
	markerBottomTooltipOffset,
	priority_colors,
	industry_icon,
	existed,
	datetime,
	date,
	daystime,
	midDuration,
	objDBTable,
	fixHtml,
	hasValue,
	isEmpty,
}
